// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { ErrosDisplay } from "../../../account/containers/ErrosDisplay";
import type { ErrorsType } from "../../../account/types/UserFormType";
import { buildCompanyInfoJson } from "../../../account/components/companies/CompileCompanytoJson";
import CompanyInfo from "../../../account/components/companies/CompanyInfo";
import { confirmAuthority } from "../../actions/resellerActions";
import { LoadingProgress, SingleSwitch, ConfirmCancelDialog } from "imagus-components";

type ResellerItemStatesType = {
  modalOpen: boolean
};

type ResellerItemPropsType = {
  company: { [key: string]: * },
  changeStatus: Function,
  isPending: boolean
};

class ResellerItem extends Component<
  ResellerItemPropsType,
  ResellerItemStatesType
> {
  constructor(props: ResellerItemPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  handleChange = (id: string): * => (event: Event) => {
    const value = event.target.checked;
    if (value === false) {
      this.switchModalStatus(true);
    } else {
      this.props.changeStatus(id, value);
    }
  };

  render(): React$Element<*> {
    const company = this.props.company;
    return (
      <TableRow>
        <TableCell className="border">{company.name}</TableCell>
        <TableCell className="normal">
          <Paper>
            <CompanyInfo company={company} />
          </Paper>
        </TableCell>
        <TableCell className="normal">
          {this.props.isPending ? (
            <LoadingProgress />
          ) : (
            <SingleSwitch
              value={company.authorisedReseller === 1}
              name={company.uuid}
              handleChange={this.handleChange(company.uuid)}
              label={["Confirmed", "Pending"]}
              isRequired={false}
            />
          )}
        </TableCell>
        <ConfirmCancelDialog
          open={this.state.modalOpen}
          handleModalStatus={this.switchModalStatus}
          deleteFunction={(): * => this.props.changeStatus(company.uuid, false)}
          deleteWord="Remove"
          itemName={company.name}
          extraWord="from the Authorised List"
        />
      </TableRow>
    );
  }
}

type ResellerListStateType = {
  errors: ErrorsType,
  pendingList: Array<string>
};

class ResellerList extends Component<*, ResellerListStateType> {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      pendingList: []
    };
  }

  changeStatus = (companyId: string, checked: boolean): * => {
    let pendingList = [...this.state.pendingList];
    pendingList.push(companyId);
    this.setState({ pendingList: pendingList });
    this.props.actions.confirmAuthority(
      companyId,
      "authorisedReseller",
      checked ? "TRUE" : "UNCONFIRMED",
      this.setDone,
      this.setFail
    );
  };

  setFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors
    });
  };

  setDone = (companyId: string): * => {
    let pendingList = [...this.state.pendingList];
    let index = pendingList.indexOf(companyId);
    pendingList.splice(index, 1);
    this.setState({
      pendingList: pendingList
    });
  };

  render(): React$Element<*> {
    const companies = this.props.resellers;
    const list =
      companies &&
      companies.map(
        (row: *, i: number): * => {
          const company = buildCompanyInfoJson(row);
          return (
            <ResellerItem
              company={company}
              changeStatus={this.changeStatus}
              isPending={this.state.pendingList.indexOf(company.uuid) !== -1}
              key={i}
            />
          );
        }
      );
    if (!companies) {
      return <LoadingProgress />;
    } else {
      return (
        <div className="app-panel-content">
          <div className="top-banner">
            <ErrosDisplay errors={this.state.errors} form="resellers" />
          </div>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <Table className="app-table center">
                <TableHead>
                  <TableRow>
                    <TableCell className="border">Company Name</TableCell>
                    <TableCell className="border">Company Detail</TableCell>
                    <TableCell className="border">Authority Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{list}</TableBody>
              </Table>
            </Grid>
          </Grid>
        </div>
      );
    }
  }
}

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ confirmAuthority }, dispatch)
});

export default connect(
  null,
  mapDispatchToProps
)(ResellerList);
